import { useThemeStore } from "@stores/theme.store";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Input, message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { NoticeType } from "antd/es/message/interface";
import { PopupSuccess } from "@components/general/popup";
import { linkPage } from "@utils/router";
import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";

export const SettingChangePasswordPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");
  const [inputDisabled, setInputDisabled] = useState<boolean>(true);
  const [popupSuccess, setPopupSuccess] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });

  const gender = dataNis?.data?.gender ?? "";
  const nis = state.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  const { mutate: onUpdatePassword, isPending: isPendingUpdateBio } =
    useMutation({
      mutationFn: SchoolService.updatePassword,
      onSuccess: (response) => {
        setPopupSuccess(true);
      },
      onError: (error: any) => {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(error.message ?? "Internal Error");
      },
    });

  const { mutate: checkPassword, isPending: isPendingCheckPassword } =
    useMutation({
      mutationFn: SchoolService.checkPassword,
      onSuccess: (response) => {
        if (response.status === false) {
          setShowMessage(true);
          setMessageType("error");
          setShowMessageText(response.message);
        } else {
          setInputDisabled(false);
        }
      },
      onError: (error: any) => {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(error.message ?? "Internal Error");
      },
    });

  useEffect(() => {
    setAppBar({ title: "Ubah Password", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      title: "Ubah Password",
      filter: false,
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4">
        <div className="tw-mb-4 tw-flex tw-items-center tw-rounded-md tw-bg-other-100 tw-text-center card-body">
          <div className="tw-me-4">
            <img
              src={
                isPending
                  ? MaleLogo
                  : data?.data?.foto === null || data?.data?.foto === ""
                  ? gender === "Pria" || gender === "PRIA" || gender === ""
                    ? MaleLogo
                    : FemaleLogo
                  : `https://sipiat2.pesantrenalirsyad2.org/assets/fotosiswa/${data?.data?.foto}`
              }
              alt=""
              className="tw-w-[60px] tw-h-[60px] tw-object-cover tw-rounded-full tw-aling-middle"
            />
          </div>
          <div className="tw-text-left">
            <div className="tw-text-lg tw-font-medium tw-text-primary">
              {data?.data?.namasiswa ?? "---"}
            </div>
            <div className="tw-text-sm tw-text-neutral-text-2">
              Kelas {data?.data?.kelas}
            </div>
          </div>
        </div>

        <Form
          className=""
          autoComplete="off"
          onFinish={(data) =>
            onUpdatePassword({
              nis: nis,
              password: data.password,
            }) as any
          }
        >
          <div className="tw-mb-4 tw-bg-other-100 tw-rounded-md card-body">
            <Form.Item
              label="Password Lama"
              name="oldPassword"
              className="tw-mb-4"
            >
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder=""
                onBlur={(data) => {
                  checkPassword({
                    nis: nis,
                    oldPassword: data.target.value,
                  }) as any;
                }}
              />
            </Form.Item>

            <Form.Item
              label="Password Baru"
              name="password"
              className="tw-mb-4"
            >
              <Input.Password
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Password"
                // disabled={inputDisabled}
              />
            </Form.Item>
          </div>

          <div className="tw-bg-other-100 tw-rounded-md card-body">
            <Button
              type="primary"
              htmlType="submit"
              loading={isPendingUpdateBio || isPendingCheckPassword}
              className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
              disabled={inputDisabled}
            >
              Simpan Password
            </Button>
          </div>
        </Form>
      </div>

      <PopupSuccess
        open={popupSuccess}
        title="Berhasil!"
        message="Password berhasil diubah!"
        textConfirm="Kembali"
        onConfirm={() => navigate(linkPage.HOME_PROFILE)}
      />
    </>
  );
};
